import { makeStyles, Tooltip } from '@material-ui/core'
import { Close, SettingsBackupRestore } from '@material-ui/icons'
import React, { useState, useReducer, useEffect } from 'react'
import {
  useMutation,
  useNotify,
  useRecordContext,
  useRefresh,
  useShowContext,
  useTranslate,
} from 'react-admin'
import { ToggleType } from '../../../../core/devices/passages/passage-set-boolean-status-button'
import { PassageDto } from '../../../../core/dto/device/passages/passage.dto'
import { PassageSelectStateDialog } from '../PassageDialogs'
import {
  passageSetReverseDirectionButtonInitialState,
  passageSetReverseDirectionButtonReducer,
} from '../../../../core/devices/passages/passage-set-reverse-direction.reducer'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'

const useStyles = makeStyles({
  iconContainer: {
    position: 'relative',
    width: 34,
  },
  icon: {
    position: 'absolute',
    left: 5,
    top: 5,
    fontSize: '24px !important',
  },
  crossIcon: {
    position: 'absolute',
    left: 0,
    top: 0,
    fontSize: 34,
    opacity: 0.8,
  },
})

export const PassageSetReverseDirectionCompactButton = ({ ...props }) => {
  const { disabled, reversedDirection } = props
  const notify = useNotify()
  const { loading } = useShowContext()
  const translate = useTranslate()
  const classes = useStyles()
  const hasAuthority = useHasAuthority()

  const [{ mutateQuery }, dispatch] = useReducer(
    passageSetReverseDirectionButtonReducer,
    passageSetReverseDirectionButtonInitialState,
  )
  const [dialogOpen, setDialogOpen] = useState(false)
  const [state, setState] = useState(false)
  const passage = useRecordContext<PassageDto>()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const refresh = useRefresh()

  useEffect(() => {
    if (state) {
      dispatch({ type: ToggleType.OFF })
    } else {
      dispatch({ type: ToggleType.ON })
    }
  }, [state])

  const handleReverseDirection = async () => {
    const query = mutateQuery?.(passage)
    await mutate(query, {
      returnPromise: true,
      onFailure: (err) => notify(err?.message, 'error'),
    })
    refresh()
  }

  return (
    <>
      <PassageSelectStateDialog
        open={dialogOpen}
        confirm={handleReverseDirection}
        method="reverseDirection"
        close={() => setDialogOpen(false)}
        state={state}
        setState={setState}
        OnIcon={<SettingsBackupRestore className={classes.icon} />}
        OffIcon={
          <>
            <SettingsBackupRestore className={classes.icon} />
            <Close fontSize="large" className={classes.crossIcon} />
          </>
        }
      />
      <Tooltip
        title={translate('resources.modules.fields.directionReversed')}
        onClick={
          !loading &&
          !mutationLoading &&
          !disabled &&
          hasAuthority(
            Authority.PASSAGES_SET_REVERSED_ROTATION_DIRECTION_BUTTON,
          )
            ? () => setDialogOpen(true)
            : undefined
        }
      >
        <div
          className={classes.iconContainer}
          style={{
            cursor:
              !loading &&
              !mutationLoading &&
              !disabled &&
              hasAuthority(
                Authority.PASSAGES_SET_REVERSED_ROTATION_DIRECTION_BUTTON,
              )
                ? 'pointer'
                : 'default',
          }}
        >
          <SettingsBackupRestore className={classes.icon} />
          {!reversedDirection ? (
            <Close fontSize="large" className={classes.crossIcon} />
          ) : undefined}
        </div>
      </Tooltip>
    </>
  )
}
